import { ethers } from 'ethers';
import { DEFAULT_RPC } from '../configs';

export const defaultProvider = new ethers.providers.StaticJsonRpcProvider(DEFAULT_RPC)

export function getLibrary(provider: any): ethers.providers.Web3Provider | ethers.providers.StaticJsonRpcProvider {
  const library = new ethers.providers.Web3Provider(provider)
  // library.pollingInterval = 12000;
  return library;
}